import { apiClient } from "api/trpc/trpc-client"
import Loader from "reusable/mobx-helpers/Loader"
import OrgGuardStore from "features/main/main-router/org-guard/OrgGuardStore"
import { notNull } from "@gap/utils/utils"
import DateUtils from "@gap/utils/date-utils"
import { OrgDto } from "@gap/backend/app-services/org/models/OrgDto"
import { namingConfig } from "@gap/utils/config/naming-config"
import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"
import { DocShareDto } from "@gap/backend/app-services/doc-share/models/DocShareDto"
import { makeAutoObservable } from "mobx"
import { pdfClient } from "api/trpc-pdf/trpc-client"

export interface DocViewPlanPageStoreProps {
   clientOrgId: string
   orgGuardStore: OrgGuardStore
}

export default class DocViewPlanPageStore {
   sp
   loader = new Loader(true)
   lastUpdatedDateForBusinessPlan: string | undefined
   businessPlanDocumentUrl: string | undefined = undefined
   private _clientOrg: OrgDto.minimal | undefined = undefined

   constructor(sp: DocViewPlanPageStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
   }

   get docTitle() {
      return `${namingConfig.businessPlan.singular} as at ${this.lastUpdatedDateForBusinessPlan}`
   }

   get businessPlanShareDocument(): DocShareDto.BusinessPlanDocument {
      return {
         type: 'business-plan-document',
         name: this.docTitle,
         workItemId: ''
      }
   }

   get clientOrg() {
      return notNull(this._clientOrg)
   }

   fetch = async () => {
      await this.loader.executeLoading(async () => {
         if (this.sp.orgGuardStore.userHasBusinessPlanPermission) {
            const myOrg = notNull(this.sp.orgGuardStore.org)
            this._clientOrg = myOrg.orgType === 'client' ? myOrg : await apiClient.org.getMinimalOrgById.query({ orgId: this.sp.clientOrgId })

            if (this._clientOrg.businessPlanFinalisedDate) {
               this.businessPlanDocumentUrl = await pdfClient.ensureBusinessPlanExists.query({
                  finalisedAt: this._clientOrg.businessPlanFinalisedDate,
                  clientOrgId: this.sp.clientOrgId
               })

               this.lastUpdatedDateForBusinessPlan = DateUtils.formatDate(new Date(this._clientOrg.businessPlanFinalisedDate), 'date-full-month')
            }
         }
      })
   }
}

export const { Provider: DocViewPlanPageStoreProvider, useProvidedStore: useDocViewPlanPageStore } = createStoreContext(DocViewPlanPageStore)
